var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useMemo, useState } from 'react';
import { TagType, WidgetType } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import Tags from '@shared/tags/Tags';
import Modal from '@shared/modal/Modal';
import Manager from '@shared/modal/Manager';
import TextInput from '@shared/input/TextInput';
import { CheckBox } from '@shared/input/CheckBox';
import SelectInput from '@shared/input/SelectInput';
import ModalHeader from '@shared/modal/ModalHeader';
import ModalFooter from '@shared/modal/ModalFooter';
import { useTagContext } from '@data/tag/tagContext';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import { useCreateWidget, useUpdateWidget } from '@data/widgets/widgetActions';
import { NumberFormatType, numberFormatTypesMeta } from '@util/enums';
import { ModalBody } from '@styled/Modal';
import { FormField, FormFieldLabel, FormTextInput } from '@styled/Form';
export default function SingleValueEditor(props) {
    return (React.createElement(Modal, { width: 600 },
        React.createElement(SingleValueEditorForm, __assign({}, props))));
}
function SingleValueEditorForm(props) {
    var _this = this;
    var _a, _b, _c;
    var L = useLanguage().L;
    var tagData = useTagContext().tagData;
    var createWidget = useCreateWidget();
    var updateWidget = useUpdateWidget();
    var _d = __read(useState(props.widget
        ? props.widget
        : {
            title: '',
            type: WidgetType.SINGLEVALUE,
            config: JSON.stringify(parseWidgetConfig(null, WidgetType.SINGLEVALUE)),
            GridId: props.gridId,
        }), 2), widgetState = _d[0], setWidgetState = _d[1];
    var widgetConfig = useMemo(function () { return parseWidgetConfig(widgetState.config, WidgetType.SINGLEVALUE); }, [widgetState.config]);
    var _e = __read(useState({}), 2), invalid = _e[0], setInvalid = _e[1];
    var validate = function (payload, payloadConfig) { return __awaiter(_this, void 0, void 0, function () {
        var invalid;
        return __generator(this, function (_a) {
            invalid = {};
            if (payloadConfig.numformat === undefined ||
                !Object.values(NumberFormatType).includes(payloadConfig.numformat)) {
                invalid.numformat = 'Non-existing number format';
            }
            return [2 /*return*/, invalid];
        });
    }); };
    function saveChanges() {
        return __awaiter(this, void 0, void 0, function () {
            var widgetCopy, _invalid, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        widgetCopy = __assign({}, widgetState);
                        return [4 /*yield*/, validate(widgetCopy, widgetConfig)];
                    case 1:
                        _invalid = _b.sent();
                        if (!(Object.keys(_invalid).length === 0)) return [3 /*break*/, 6];
                        if (!('id' in widgetCopy)) return [3 /*break*/, 3];
                        return [4 /*yield*/, updateWidget.mutateAsync(widgetCopy)];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, createWidget.mutateAsync(widgetCopy)];
                    case 4:
                        _a = _b.sent();
                        _b.label = 5;
                    case 5:
                        _a;
                        Manager.closeModal();
                        return [3 /*break*/, 7];
                    case 6:
                        setInvalid(_invalid);
                        _b.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    function handleTitleChange(newTitle) {
        var widgetCopy = __assign({}, widgetState);
        widgetCopy.title = newTitle;
        setWidgetState(widgetCopy);
    }
    function changeConfig(changes) {
        var e_1, _a;
        var widgetConfigCopy = __assign({}, widgetConfig);
        try {
            for (var changes_1 = __values(changes), changes_1_1 = changes_1.next(); !changes_1_1.done; changes_1_1 = changes_1.next()) {
                var _b = __read(changes_1_1.value, 2), key = _b[0], value = _b[1];
                widgetConfigCopy[key] = value;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (changes_1_1 && !changes_1_1.done && (_a = changes_1.return)) _a.call(changes_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var widgetCopy = __assign({}, widgetState);
        widgetCopy.config = JSON.stringify(widgetConfigCopy);
        setWidgetState(widgetCopy);
    }
    function addTag(tagId, field) {
        var widgetConfigCopy = __assign({}, widgetConfig);
        widgetConfigCopy[field].push(tagId);
        var widgetCopy = __assign({}, widgetState);
        widgetCopy.config = JSON.stringify(widgetConfigCopy);
        setWidgetState(widgetCopy);
    }
    function removeTag(tagId, field) {
        var widgetConfigCopy = __assign({}, widgetConfig);
        widgetConfigCopy[field] = widgetConfigCopy[field].filter(function (tId) { return tId !== tagId; });
        var widgetCopy = __assign({}, widgetState);
        widgetCopy.config = JSON.stringify(widgetConfigCopy);
        setWidgetState(widgetCopy);
    }
    var accountTagObjects = widgetConfig.accountTags
        .map(function (tagId) { return tagData.tagById[tagId]; })
        .filter(function (t) { return t !== undefined; });
    var filterTagObjects = widgetConfig.filterTags
        .map(function (tagId) { return tagData.tagById[tagId]; })
        .filter(function (t) { return t !== undefined; });
    var comparisonTagObjects = widgetConfig.comparisonTags
        .map(function (tagId) { return tagData.tagById[tagId]; })
        .filter(function (t) { return t !== undefined; });
    var accountTagFormat = (_b = (_a = accountTagObjects[0]) === null || _a === void 0 ? void 0 : _a.numberFormat) === null || _b === void 0 ? void 0 : _b.format;
    var accountTagName = (_c = accountTagObjects[0]) === null || _c === void 0 ? void 0 : _c.name;
    var title = props.widget ? "".concat(L('Editing single value'), " \"").concat(props.widget.title, "\"") : L('Create new single value');
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { title: title }),
        React.createElement(ModalBody, null,
            React.createElement("form", null,
                React.createElement(TextInput, { label: L('Title'), value: widgetState.title, placeholder: L('Leave empty for auto-generated'), name: "title", onChange: function (e) { return handleTitleChange(e.target.value); }, bottomMargin: true }),
                React.createElement(SelectInput, { name: "numformat", disabled: !!accountTagFormat, value: !!accountTagFormat ? null : widgetConfig.numformat, placeholder: !!accountTagFormat ? "Using format from variable tag \"".concat(accountTagName, "\"") : '', label: L('Format'), onChange: function (e) {
                        if (!e.target.value) {
                            return;
                        }
                        changeConfig([['numformat', e.target.value]]);
                    }, options: Object.entries(NumberFormatType).map(function (_a) {
                        var _b = __read(_a, 2), key = _b[0], value = _b[1];
                        return ({
                            label: L(numberFormatTypesMeta[value].label),
                            value: value,
                        });
                    }), invalid: !!invalid.numformat, invalidString: invalid.numformat, bottomMargin: true }),
                React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(FormFieldLabel, null, L('Variable')),
                    React.createElement(Tags, { tags: accountTagObjects, select: function (tagId) { return addTag(tagId, 'accountTags'); }, remove: function (tagId) { return removeTag(tagId, 'accountTags'); }, customButton: accountTagObjects.length > 0 ? function () { return React.createElement(React.Fragment, null); } : undefined, filterByTypes: [TagType.Account] })),
                React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(FormFieldLabel, null, L('Filter Dimensions')),
                    React.createElement(Tags, { tags: filterTagObjects, select: function (tagId) { return addTag(tagId, 'filterTags'); }, remove: function (tagId) { return removeTag(tagId, 'filterTags'); }, filterByTypes: [TagType.Dimension] })),
                React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(FormFieldLabel, null, L('Comparison Dimensions')),
                    React.createElement(Tags, { tags: comparisonTagObjects, select: function (tagId) { return addTag(tagId, 'comparisonTags'); }, remove: function (tagId) { return removeTag(tagId, 'comparisonTags'); }, filterByTypes: [TagType.Dimension] })),
                React.createElement(TextInput, { label: L('Comparison custom text'), value: widgetConfig.comparisonCustomText, placeholder: L('Leave empty for auto-generated'), name: "comparisonCustomText", onChange: function (e) { return changeConfig([['comparisonCustomText', e.target.value]]); }, bottomMargin: true }),
                React.createElement(FormField, null,
                    React.createElement(CheckBox, { checked: widgetConfig.useTagSlicers, label: L('Use Data from Dimension Slicers'), action: function () { return changeConfig([['useTagSlicers', !widgetConfig.useTagSlicers]]); } })),
                React.createElement(FormField, null,
                    React.createElement(CheckBox, { checked: widgetConfig.dataEntry, label: L('Data Entry'), action: function () {
                            var newValue = !widgetConfig.dataEntry;
                            changeConfig([
                                ['dataEntry', newValue],
                                ['showDataEntryButtons', newValue],
                            ]);
                        } }),
                    React.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '12px',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                        } },
                        React.createElement(CheckBox, { checked: widgetConfig.showDataEntryButtons, label: L('Show Buttons'), action: function () {
                                return changeConfig([['showDataEntryButtons', !widgetConfig.showDataEntryButtons]]);
                            }, disabled: !widgetConfig.dataEntry }),
                        React.createElement(FormTextInput, { name: "dataEntryButtonStep", onChange: function (e) { return changeConfig([['dataEntryButtonStep', e.target.value]]); }, value: widgetConfig.dataEntryButtonStep, placeholder: L('Step'), disabled: !widgetConfig.showDataEntryButtons, style: { width: '64px' } }))))),
        React.createElement(ModalFooter, { done: saveChanges })));
}
